import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { currency } from 'src/app/modules/cases/components/create-case/ras-form/ras-form.utils';

enum Texts {
  currency = '44.Moneda, Tilde el cuadro que corresponda *',
  bsd = 'Bolivar digital',
  other = 'Otra moneda',
}
@Component({
  selector: 'description-ras-currency',
  templateUrl: './description-ras-currency.component.html',
  styleUrls: ['./description-ras-currency.component.scss'],
})
export class DescriptionRasCurrencyComponent implements OnInit {
  public Texts = Texts;
  currency = currency;
  @Input() form: FormGroup;
  @Output() formChange = new EventEmitter<FormGroup>();
  constructor() {}

  ngOnInit() {}

  get isOtherCurrency() {
    return this.form.get('typeOfCurrency').value == 'other';
  }

  onTypeOfCurrencyChange() {
    if (!this.isOtherCurrency) {
      this.form.get('currency').setValue('bsd');
    } else {
      this.form.get('currency').setValue('');
    }
  }
}
